import React, { useState, useRef } from "react";
import "../styles/Login.css";
import API_BASE_URL from "../Config.js";

const TERMS_TEXT = `[이용약관]

* 본 페이지는 세종대학교 산학협력단 신청/접수 화면입니다. 

* 과제의 신청, 협약 등 산학협력단 명의의 직인날인을 신청하는 양식입니다. 원활한 진행을 위해 필요 내용을 충실히 입력해 주시기 바랍니다.

* 모든 과정은 대학의 지침에 따라 내부행정절차를 준수하여야 하는 바, 시일이 소요되므로 필요시기를 고려하시어 충분한 시간을 갖고 신청해 주시기 바랍니다.

본인은 위의 내용을 충분히 숙지하였으며, 이에 동의합니다.`;
const PRIVACY_TEXT = `[개인정보 수집 및 이용안내] 

본 기관(세종대학교)은 신청서 접수 및 사용자 식별, 원활한 서비스 제공을 위하여 관련 법령(개인정보 보호법 제15조 등)에 의거하여 귀하의 개인정보를 수집·이용하고자 합니다. 내용을 자세히 읽으신 후 동의 여부를 결정해 주시기 바랍니다.

1. 개인정보의 수집 · 이용 목적
- 신청서 접수 처리, 본인 확인 및 사용자 식별
- 접수 관련 안내 사항 고지 및 민원·문의 사항 처리
- 부정 이용 방지 및 서비스 이용 기록 관리

2. 수집하는 개인정보의 항목
- 필수항목: 학번 또는 직번, 성명, 전화번호 뒷자리 4자리
※ 고유식별정보(주민등록번호 등) 및 민감정보는 일체 수집하지 않습니다.

3. 개인정보의 보유 및 이용 기간
- 수집된 개인정보는 목적 달성 시(신청서 처리 완료 및 관련 사업 종료 시) 또는 귀하의 파기 요청 시까지 보유·이용됩니다.
- 단, 관련 법령(예: 전자상거래 등에서의 소비자보호에 관한 법률 등)의 규정에 의하여 보존할 필요가 있는 경우, 해당 법령에서 정한 일정 기간 동안 안전하게 보관 후 파기합니다.

4. 동의를 거부할 권리 및 동의 거부에 따른 불이익 고지
- 귀하는 본 개인정보 수집·이용 동의에 거부할 권리가 있습니다.
- 다만, 본 동의는 신청서 접수 및 본인 식별을 위한 최소한의 필수 정보 수집에 대한 동의이므로, 동의를 거부하실 경우 신청서 접수 및 시스템 이용이 제한될 수 있습니다.

본인은 위의 내용을 충분히 숙지하였으며, 이에 동의합니다.
`;

function Login({ onLogin }) {
    const [loginid, setLoginId] = useState("");
    const [loginpw, setLoginPw] = useState("");
    const passwordRef = useRef(null); // 패스워드 input 참조
    
    const [agreed, setAgreed] = useState({ terms: false, privacy: false });
    const [isModalOpen, setIsModalOpen] = useState(false);
    
    // 모달을 통과했을 때 최종 로그인을 진행하기 위해 임시로 서버 응답 데이터를 저장할 State
    const [tempUserData, setTempUserData] = useState(null);

    const handleAllAgree = (e) => {
        const isChecked = e.target.checked;
        setAgreed({ terms: isChecked, privacy: isChecked });
    };

    const handleIdKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            if (passwordRef.current) {
                passwordRef.current.focus();
            }
        }
    };

    // [수정] 로그인 성공 처리를 공통 함수로 분리
    const completeLogin = (userData) => {
        sessionStorage.setItem("token", userData.token);
        sessionStorage.setItem("userName", userData.user.name);
        sessionStorage.setItem("userId", userData.user.login_id);
        sessionStorage.setItem("grantFg", userData.user.grant_fg);

        onLogin(userData.user); // 부모 컴포넌트로 전달
    };

   // [수정] 모달 확인 버튼 클릭 시 처리 로직 완성
    const saveOk = async () => {
        if (!agreed.terms || !agreed.privacy) {
            alert("모든 필수 약관에 동의하셔야 서비스 이용이 가능합니다.");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/updateindivisual`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ login_id: loginid }),
            });

            // 📌 해결 핵심: response.json()을 바로 쓰지 말고 text()로 먼저 받습니다.
            const rawText = await response.text();
            //console.log("서버가 보낸 실제 데이터:", rawText);

            let data = {};
            try {
                // 불순물이 섞여 있을 수 있으므로 파싱 시도
                data = JSON.parse(rawText);
            } catch (e) {
                console.warn("서버 응답 파싱 실패 (텍스트 섞임), 하지만 처리를 계속합니다.");
            }

            // 📌 중요: JSON 파싱 결과와 상관없이 HTTP 상태 코드가 200(ok)이면 성공으로 간주합니다.
            if (response.ok) {
                if (tempUserData) {
                    alert("🎉 약관 동의가 완료되었습니다.");
                    setIsModalOpen(false);
                    completeLogin(tempUserData); // 임시 저장해둔 데이터로 최종 로그인
                } else {
                    alert("로그인 정보가 유실되었습니다. 다시 시도해 주세요.");
                }
            } else {
                alert(data.error || "동의 정보 저장에 실패했습니다. 다시 시도해 주세요.");
            }
        } catch (error) {
            console.error("약관 동의 업데이트 에러:", error);
            alert("서버 통신 중 오류가 발생했습니다.");
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!loginid || !loginpw) {
            alert("아이디와 비밀번호를 입력해 주세요.");
            return;
        }

        try {
            const response = await fetch(`${API_BASE_URL}/login`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ login_id: loginid, login_pw: loginpw }),
            });

            if (!response.ok) {
                const text = await response.text();
                alert(text);
                return;
            }

            const loginData = await response.json(); // 로그인 성공 데이터 파싱

            // 개인정보 동의 여부 체크 API 호출
            const chIDResponse = await fetch(`${API_BASE_URL}/checkindivisual`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ login_id: loginid }),
            });
            //console.log("보낸데이터:", loginid);
            
            const chIDData = await chIDResponse.json();
            //console.log(chIDData.IndivisualFg);

            // 정보 동의 안 한 상태 (예: IndivisualFg가 false이거나 유효값일 때 상황에 맞춤)
            // 만약 서버에서 미동의자를 true로 주면 기재하신 대로 유지, 미동의를 0이나 false로 주면 !chIDData.IndivisualFg 로 조건 변경 필요
            if (chIDData.IndivisualFg === 0) { 
                setTempUserData(loginData); // 나중에 로그인 완료 처리를 위해 임시 저장
                setIsModalOpen(true);       // 모달 창 열기
                return;
            }

            // 이미 예전에 동의 완료한 정상 사용자는 바로 로그인 시켜줌
            if (loginData.token) {
                completeLogin(loginData);
            } else {
                alert("로그인 실패: " + (loginData.error || ""));
            }
        } catch (error) {
            alert("서버와 통신 중 오류가 발생했습니다.");
            console.error("로그인 에러:", error);
        }
    };

    return (
    <div className="login-slide">
        {/* 조금 더 신뢰감을 주는 모던한 네이밍 텍스트 톤앤매너 변경 */}
        <h2 className="title">신청서 접수 시스템</h2>

        <form onSubmit={handleSubmit} className="login-form">
            <input
                value={loginid}
                onChange={(e) => setLoginId(e.target.value)}
                onKeyDown={handleIdKeyDown}
                placeholder="아이디를 입력하세요"
            />

            <input
                type="password"
                ref={passwordRef}
                value={loginpw}
                onChange={(e) => setLoginPw(e.target.value)}
                placeholder="비밀번호를 입력하세요"
                autoComplete="off"
            />

            <button type="submit">로그인</button>
        </form>

        {/* 약관 동의 컴포넌트는 로그인 시 백그라운드 레이어 스택 상단에 정확히 배치됩니다 */}
        {isModalOpen && (
          <div className="step-container" style={{ position: 'relative' }}> {/* 🌟 X 버튼 배치를 위해 relative 추가 */}

              {/* 🌟 [신규 추가] 우측 상단 닫기(X) 버튼 */}
              <button 
                type="button"
                onClick={() => {
            // 🌟 정의되지 않은 onCancel 대신, 모달 열림 상태를 직접 false로 바꿔서 닫아줍니다.
            setIsModalOpen(false); 
          }}
                style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  background: 'none',
                  border: 'none',
                  fontSize: '20px',
                  fontWeight: '300',
                  color: '#94A3B8', // 세련된 Slate 그레이 색상
                  cursor: 'pointer',
                  padding: '5px',
                  lineHeight: '1',
                  transition: 'color 0.2s ease',
                }}
                onMouseEnter={(e) => e.currentTarget.style.color = '#475569'} // 마우스 올렸을 때 더 짙게
                onMouseLeave={(e) => e.currentTarget.style.color = '#94A3B8'} // 마우스 뗐을 때 원래대로
                aria-label="약관 동의 모달 닫기"
              >
                ✕
              </button>
            
              <h2 className="modal-title" style={{ marginTop: 0, fontSize: '1.4rem', color: '#1e293b' }}>약관 동의</h2>
            
              <div className="all-agree" style={{ marginBottom: '15px', fontWeight: 'bold' }}>
                <label style={{ cursor: 'pointer' }}><input type="checkbox" checked={agreed.terms && agreed.privacy} onChange={handleAllAgree} /> 전체 동의하기</label>
              </div>
            
              <div className="terms-section" style={{ marginBottom: '15px' }}>
                <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: '600', color: '#475569' }}>이용약관 (필수)</p>
                <textarea className="terms-box" readOnly value={TERMS_TEXT} />
                <label className="check-wrapper" style={{ fontSize: '13px', cursor: 'pointer' }}><input type="checkbox" checked={agreed.terms} onChange={() => setAgreed(p=>({...p, terms:!p.terms}))} /> 동의함</label>
              </div>
            
              <div className="terms-section" style={{ marginBottom: '20px' }}>
                <p style={{ margin: '0 0 4px 0', fontSize: '13px', fontWeight: '600', color: '#475569' }}>개인정보 수집 및 이용 (필수)</p>
                <textarea className="terms-box" readOnly value={PRIVACY_TEXT} />
                <label className="check-wrapper" style={{ fontSize: '13px', cursor: 'pointer' }}><input type="checkbox" checked={agreed.privacy} onChange={() => setAgreed(p=>({...p, privacy:!p.privacy}))} /> 동의함</label>
              </div>
            
              <button onClick={saveOk} className="main-btn" style={{
                  width: '100%', padding: '12px', borderRadius: '8px', border: 'none',
                  backgroundColor: '#0284c7', color: 'white', fontWeight: 'bold', cursor: 'pointer'
              }}>동의 및 확인</button>
            </div>
        )}

    </div>
);

}

export default Login;
